"use client";

import Richtext from "../../Richtext";
import { DirectusImage } from "@/components/DirectusImage";
import CountUp from "react-countup";
import "./index.css";
import { getDecimals } from "@/lib/utils";

export default function CompanyIntroduction(props: {
  data?: {
    content?: string;
    image?: string;
    video?: string;
    data_list?: {
      name?: string;
      value?: number;
      unit?: string;
    }[];
  };
}) {
  return (
    <div className="flex w-full flex-col md:flex-row md:items-center md:justify-between md:gap-x-4">
      <div className="md:max-w-[420px]">
        <div className="company-introduction hidden max-md:text-center md:block ">
          <Richtext data={{ content: props?.data?.content }} />
        </div>
        <div className="company-introduction max-md:text-center md:hidden">
          {/* 过滤&nbsp;和换行 */}
          <Richtext
            data={{
              content: props?.data?.content
                // ?.replace(/\s+/g, "")
                ?.replace(/\n/g, "")
                ?.replace(/&nbsp;/g, ""),
            }}
          />
        </div>
        <ul className="flex gap-x-3 max-md:mb-4 max-md:mt-3 max-md:justify-between md:gap-x-16">
          {props?.data?.data_list?.map((el, index) => (
            <li
              key={index}
              className="max-md:flex max-md:grow max-md:flex-row-reverse max-md:justify-between max-md:rounded-lg max-md:px-3 max-md:py-2 max-md:shadow-md">
              <p className="flex items-end">
                <span className="text-2xl en:text-xl font-bold text-primary md:text-3xl">
                  <CountUp
                    start={0}
                    end={el.value || 0}
                    decimals={getDecimals(el.value || 0)}
                    suffix="+"
                    enableScrollSpy
                    scrollSpyOnce
                  />
                </span>
                <span className="ml-2 text-xs text-primary md:text-base md:font-bold">
                  {el.unit}
                </span>
              </p>
              <p className="text-xs max-md:line-clamp-2 max-md:w-1/2 max-md:text-zinc-300 md:mt-2 md:text-base">
                {el.name}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className="overflow-hidden rounded-xl md:h-[374px] md:w-[664px]">
        {!props?.data?.video && props?.data?.image && (
          <DirectusImage
            id={props?.data?.image}
            width={664}
            height={374}
            className="h-full w-full object-cover"
            alt=""
          />
        )}
        {props?.data?.video && (
          <video
            src={`${process.env.NEXT_PUBLIC_ASSETS}/${props?.data?.video}`}
            poster={
              props?.data?.image
                ? `${process.env.NEXT_PUBLIC_ASSETS}/${props?.data?.image}?transforms=[["blur",70]]`
                : undefined
            }
            className="h-full w-full object-cover"></video>
        )}
      </div>
    </div>
  );
}
